import http from "@/services/http";

/**
 * Lista as notas clínicas de um paciente (tabela patient_clinical_notes),
 * mais recente primeiro. Filtro opcional por kind.
 *
 * @param {number|string} patientId
 * @param {string|null} kind  life_history | general | other
 * @returns {Promise<object[]>}
 */
export async function getNotesByPatient(patientId, kind = null) {
  const { data } = await http.get(
    `/api/patient-clinical-notes/get-by-patient/${patientId}`,
    { params: kind ? { kind } : {} },
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Cria uma nota clínica.
 * @param {number|string} patientId
 * @param {object} payload { kind, content }
 */
export function createNote(patientId, payload) {
  return http.post("/api/patient-clinical-notes/create", {
    patient_id: patientId,
    ...payload,
  });
}

/**
 * Atualiza uma nota clínica.
 */
export function updateNote(id, payload) {
  return http.put(`/api/patient-clinical-notes/update/${id}`, payload);
}

/**
 * Remove uma nota clínica (soft delete).
 */
export function deleteNote(id) {
  return http.delete(`/api/patient-clinical-notes/delete/${id}`);
}
